<label for="name" class="form-label" translate="field.surname"></label>
<div [formGroup]="registerForm" class="input-group has-validation">
  <input type="text" class="form-control" id="surname" formControlName="surname"
         [ngClass]="{ 'is-invalid': isInvalid() }"
         data-lpignore='true'
  />
  <span class="input-group-text"><i class="fas fa-address-book mx-2"></i></span>
  <div class="invalid-feedback" translate="signIn.surnameRequired"></div>
</div>
